const transitionDurationMs = {
  enter: 150,
  exit: 100
};
const backdrop = "_j0jb1wna2p9";
const card = "_j0jc4z1crz";
const container = "_j0jc14x20kd";
const closeButton = "_j0jc9maqcw";

export { backdrop, card, closeButton, container, transitionDurationMs };
import "./atom.overlay-lightbox.style.linaria.module.css";
//# sourceMappingURL=atom.overlay-lightbox.style.js.map
